/**
 * Shared team role constants.
 *
 * Team member roles are plain strings on the wire (no enum in the generated
 * API client), so call sites tended to sprinkle raw 'coach' / 'manager'
 * literals around permission checks. This is the single place that names
 * them.
 */
export const Role = {
  Manager: "manager",
  Coach: "coach",
  Athlete: "athlete",
} as const;

export type Role = (typeof Role)[keyof typeof Role];

export function hasRole(roles: string[] | undefined, role: Role): boolean {
  return roles?.includes(role) ?? false;
}
